import { IconButton, Stack } from "@mui/material";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useNavigate } from "react-router-dom";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useDeleteJourneyMutation } from "src/api/settings/sales";
import { useTranslation } from "react-i18next";
import { specificBranchHasPermission } from "src/utils";
import { SalesPermissions } from "src/constants/permissions";

const TableActions = ({
  rowId,
  rowName,
  refetch,
  type,
  branchId,
  is_imported,
  is_processed,
}: {
  rowId: number;
  rowName: string;
  refetch: Function;
  type: string;
  branchId: number;
  is_imported: boolean;
  is_processed: boolean;
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const { t } = useTranslation("settings");
  const { t: generalT } = useTranslation("general");

  const { mutate, isPending, status, error } = useDeleteJourneyMutation();

  //permissions
  const editPermission = specificBranchHasPermission(
    SalesPermissions.editSale,
    branchId
  );
  const deletePermission = specificBranchHasPermission(
    SalesPermissions.deleteSale,
    branchId
  );

  const navigateToEditPage = () => {
    const navigateTo =
      is_imported && !is_processed
        ? `/add-sales?journeyId=${rowId}&importBranchId=${branchId}`
        : `/sales/${rowId}/edit`;
    navigate(navigateTo);
  };

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    mutate(rowId);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: generalT("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || generalT("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      {editPermission && type !== "dayoff" && (
        <IconButton onClick={navigateToEditPage}>
          <img src={EditIcon} alt="" />
        </IconButton>
      )}

      {deletePermission && (
        <IconButton onClick={handleClickOpen}>
          <img src={DeleteIcon} alt="" />
        </IconButton>
      )}

      <ConfirmPopup
        open={open}
        item={rowName}
        handleClose={handleClose}
        handleConfirm={handleDelete}
        isPending={isPending}
        warningText={t("deleteSalesWarningMsg")}
      />
    </Stack>
  );
};
export default TableActions;
